import { module } from 'angular';

import { AgentBookingPhoneAccepting, default as agentBookingPhoneAccepting } from './accepting/agent-booking-phone-accepting.component.ajs';
import { AgentBookingPhoneAllocated, default as agentBookingPhoneAllocated } from './allocated/agent-booking-phone-allocated.component.ajs';
import {
  AgentBookingPhoneInprocessConference,
  default as agentBookingPhoneInprocessConference,
} from './inprocess-conference/agent-booking-phone-inprocess-conference.component.ajs';
import {
  AgentBookingPhoneInprocessScriptRedirection,
  default as agentBookingPhoneInprocessScriptRedirection,
} from './inprocess-script-redirection/agent-booking-phone-inprocess-script-redirection.component.ajs';
import { AgentBookingPhoneInprocess, default as agentBookingPhoneInprocess } from './inprocess/agent-booking-phone-inprocess.component.ajs';
import { ContactViewPhoneLayout, default as contactViewPhoneLayout } from './layout/contact-view-phone-layout.component.ajs';
import {
  AgentBookingPhoneQualification,
  default as agentBookingPhoneQualification,
} from './qualification/agent-booking-phone-qualification.component.ajs';

export default module('contact.agent.contact-view.phone.state', [])
  .component(contactViewPhoneLayout, new ContactViewPhoneLayout())
  .component(agentBookingPhoneAccepting, new AgentBookingPhoneAccepting())
  .component(agentBookingPhoneAllocated, new AgentBookingPhoneAllocated())
  .component(agentBookingPhoneInprocess, new AgentBookingPhoneInprocess())
  .component(agentBookingPhoneInprocessConference, new AgentBookingPhoneInprocessConference())
  .component(agentBookingPhoneInprocessScriptRedirection, new AgentBookingPhoneInprocessScriptRedirection())
  .component(agentBookingPhoneQualification, new AgentBookingPhoneQualification()).name;
